namespace Areas.Constants {
    "use strict";

    export class ProjectInfoStatus {
        public static readonly approved = "Approved";
        public static readonly deleted = "DELETED";
        public static readonly completed = "Completed";
        public static readonly draft = "Draft";
        public static readonly inProcess = "InProcess";
        public static readonly submitted = "Submitted";
    }


    export const projectInfoEditableStatuses: string[] = [ProjectInfoStatus.draft];
    export const projectInfoReviewableStatuses: string[] = [ProjectInfoStatus.draft, ProjectInfoStatus.inProcess,
        ProjectInfoStatus.submitted, ProjectInfoStatus.approved, ProjectInfoStatus.completed];

    export class EicStatus {
        public static readonly deleted = "DELETED";
        public static readonly completed = "Completed";
        public static readonly draft = "Draft";
        public static readonly inProcess = "InProcess";
        public static readonly submitted = "Submitted";
    }

    export const eicEditableStatuses: string[] = [EicStatus.draft];
    export const eicReviewableStatuses: string[] = [EicStatus.draft, EicStatus.inProcess, EicStatus.submitted];
}